module.exports = __webpack_public_path__ + "static/img/reg-btn.f8bb4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/reg-btn.png
// module id = 4HEZ
// module chunks = 1